// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__26bm6","unreadBadge":"styles_unreadBadge__36rJY","modalContent":"styles_modalContent__2YKNm","modal":"styles_modal__2kQTV"};